module.exports = __webpack_public_path__ + "assets/img/001.dfdc13aa.png";